import { RSError, RSErrorOptions } from "./RSError";

/**
 * Erreurs liées au profil client (CustomerModel) :
 * paramètres Neolane manquants, etc.
 */
export class RSCustomerError<C = Record<string, unknown>> extends RSError<C> {
  constructor(message: string, context?: C, options?: RSErrorOptions) {
    super(message, context, options);
    this.name = "RSCustomerError";
    Object.setPrototypeOf(this, RSCustomerError.prototype);
  }
}
